interface Dependencies {
  dcmt?: Document;
}

export function blurActiveElement(di: Dependencies = {}): void {
  const {dcmt = document} = di;
  if (!dcmt.activeElement) return;
  (dcmt.activeElement as HTMLElement).blur();
}
